import apiClient from '../axios.js';

const BASE = '/line/rich-menu';

export const lineRichMenuService = {
  async list(params = {}) {
    return apiClient.get(BASE, { params });
  },

  async getById(id) {
    return apiClient.get(`${BASE}/${id}`);
  },

  async create(data) {
    return apiClient.post(BASE, data);
  },

  async update(id, data) {
    return apiClient.put(`${BASE}/${id}`, data);
  },

  async remove(id) {
    return apiClient.delete(`${BASE}/${id}`);
  },

  async deploy(id) {
    return apiClient.post(`${BASE}/${id}/deploy`);
  },

  async activate(id) {
    return apiClient.post(`${BASE}/${id}/activate`);
  },

  async applyAsDefault(id) {
    return apiClient.post(`${BASE}/${id}/apply-as-default`);
  },

  async setBaseMenu(id) {
    return apiClient.post(`${BASE}/${id}/set-base-menu`);
  },

  async unsetBaseMenu(id) {
    return apiClient.post(`${BASE}/${id}/unset-base-menu`);
  },

  async undeploy(id) {
    return apiClient.post(`${BASE}/${id}/undeploy`);
  },

  // 測試好友
  async listFriends(id) {
    return apiClient.get(`${BASE}/${id}/friends`);
  },

  async addFriend(id, data) {
    return apiClient.post(`${BASE}/${id}/friends`, data);
  },

  async removeFriend(groupId, friendId, lineUserId) {
    return apiClient.delete(`${BASE}/${groupId}/friends/${friendId}`, {
      params: { lineUserId }
    });
  },

  async getTierUsage(excludeGroupId = null) {
    const params = excludeGroupId ? { excludeGroupId } : {};
    return apiClient.get(`${BASE}/tier-usage`, { params });
  },

  async searchLineFriends(groupId, search) {
    return apiClient.get(`${BASE}/${groupId}/search-line-friends`, { params: { search } });
  },

  async batchDeployMember(lineConfigId) {
    return apiClient.post(`${BASE}/batch-deploy-member`, { lineConfigId });
  },

  async getDeployJob(jobId) {
    return apiClient.get(`${BASE}/deploy-jobs/${jobId}`);
  },

  async getLogs(params = {}) {
    return apiClient.get(`${BASE}/logs`, { params });
  },

  async getAnalyticsSummary(id, versionId = null) {
    const params = versionId ? { versionId } : {};
    return apiClient.get(`${BASE}/${id}/analytics/summary`, { params });
  },

  async getAnalyticsVersions(id) {
    return apiClient.get(`${BASE}/${id}/analytics/versions`);
  },

  async getAnalyticsClicks(id, params = {}) {
    return apiClient.get(`${BASE}/${id}/analytics/clicks`, { params });
  },

  async exportAnalyticsClicks(id, params = {}) {
    return apiClient.get(`${BASE}/${id}/analytics/export`, {
      params,
      responseType: 'blob'
    });
  },

  async previewAnalyticsReset(id, tabs) {
    return apiClient.post(`${BASE}/${id}/analytics/preview-reset`, { tabs });
  },

  // 圖片上傳（共用上傳端點）
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};
